import axios from 'axios'
import getApiURL from '@utils/getApiURL'

const urlParams = new URLSearchParams(document.location.search)

const submitHealthyHomeLead = async (formData) => {
  const { contactInfo } = formData
  const data = {
    ppc_ad_id__c: urlParams.get('utm_id') || '',
    ppc_campaign__c: urlParams.get('utm_campaign') || '',
    ppc_content__c: urlParams.get('utm_content') || '',
    ppc_medium__c: urlParams.get('utm_medium') || '',
    ppc_source__c: urlParams.get('utm_source') || '',
    ppc_term__c: urlParams.get('utm_term') || '',
    leadSource:
      urlParams.get('utm_source') === 'partners'
        ? 'Partners'
        : contactInfo.source,
  }
  const info = { formData, data }

  await axios.post(
    `${getApiURL('hvacServiceSubmit')}/hvacServiceSubmit`,
    JSON.stringify(info),
    { headers: { 'Content-Type': 'application/json' } }
  )
}

export default submitHealthyHomeLead
